import './home.scss';

const Home = () => {
	return (
		<section id='section-main'>
			<div id='container-cms' />
		</section>
	);
};

export default Home;
